import { mean } from "d3-array";
import { slidingWindow } from "../utils";
import { RainbowMA as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { period, sourcePath } = options;

    // Create 10 cascading SMAs
    // SMA1 = SMA(close, period)
    // SMA2 = SMA(SMA1, period)
    // ... up to SMA10

    // First SMA from source data
    const sma1Calculator = slidingWindow()
      .windowSize(period)
      .sourcePath(sourcePath)
      .accumulator((values) => mean(values));

    const sma1Results = sma1Calculator(data);

    // Prepare data with SMA1 values
    const dataWithSMA1 = data.map((d, i) => ({
      ...d,
      sma1: sma1Results[i],
    }));

    // Calculate SMA2 from SMA1
    const sma2Calculator = slidingWindow()
      .windowSize(period)
      .sourcePath("sma1")
      .accumulator((values) => mean(values));

    const sma2Results = sma2Calculator(dataWithSMA1);

    // Continue cascading for SMA3 through SMA10
    const dataWithSMA2 = dataWithSMA1.map((d, i) => ({
      ...d,
      sma2: sma2Results[i],
    }));

    const sma3Calculator = slidingWindow()
      .windowSize(period)
      .sourcePath("sma2")
      .accumulator((values) => mean(values));

    const sma3Results = sma3Calculator(dataWithSMA2);

    const dataWithSMA3 = dataWithSMA2.map((d, i) => ({
      ...d,
      sma3: sma3Results[i],
    }));

    const sma4Calculator = slidingWindow()
      .windowSize(period)
      .sourcePath("sma3")
      .accumulator((values) => mean(values));

    const sma4Results = sma4Calculator(dataWithSMA3);

    const dataWithSMA4 = dataWithSMA3.map((d, i) => ({
      ...d,
      sma4: sma4Results[i],
    }));

    const sma5Calculator = slidingWindow()
      .windowSize(period)
      .sourcePath("sma4")
      .accumulator((values) => mean(values));

    const sma5Results = sma5Calculator(dataWithSMA4);

    const dataWithSMA5 = dataWithSMA4.map((d, i) => ({
      ...d,
      sma5: sma5Results[i],
    }));

    const sma6Calculator = slidingWindow()
      .windowSize(period)
      .sourcePath("sma5")
      .accumulator((values) => mean(values));

    const sma6Results = sma6Calculator(dataWithSMA5);

    const dataWithSMA6 = dataWithSMA5.map((d, i) => ({
      ...d,
      sma6: sma6Results[i],
    }));

    const sma7Calculator = slidingWindow()
      .windowSize(period)
      .sourcePath("sma6")
      .accumulator((values) => mean(values));

    const sma7Results = sma7Calculator(dataWithSMA6);

    const dataWithSMA7 = dataWithSMA6.map((d, i) => ({
      ...d,
      sma7: sma7Results[i],
    }));

    const sma8Calculator = slidingWindow()
      .windowSize(period)
      .sourcePath("sma7")
      .accumulator((values) => mean(values));

    const sma8Results = sma8Calculator(dataWithSMA7);

    const dataWithSMA8 = dataWithSMA7.map((d, i) => ({
      ...d,
      sma8: sma8Results[i],
    }));

    const sma9Calculator = slidingWindow()
      .windowSize(period)
      .sourcePath("sma8")
      .accumulator((values) => mean(values));

    const sma9Results = sma9Calculator(dataWithSMA8);

    const dataWithSMA9 = dataWithSMA8.map((d, i) => ({
      ...d,
      sma9: sma9Results[i],
    }));

    const sma10Calculator = slidingWindow()
      .windowSize(period)
      .sourcePath("sma9")
      .accumulator((values) => mean(values));

    const sma10Results = sma10Calculator(dataWithSMA9);

    // Combine all results
    return data.map((d, i) => ({
      sma1: sma1Results[i],
      sma2: sma2Results[i],
      sma3: sma3Results[i],
      sma4: sma4Results[i],
      sma5: sma5Results[i],
      sma6: sma6Results[i],
      sma7: sma7Results[i],
      sma8: sma8Results[i],
      sma9: sma9Results[i],
      sma10: sma10Results[i],
    }));
  }

  calculator.undefinedLength = function () {
    const { period } = options;
    // Each cascade adds (period - 1) undefined values
    // Total undefined = 10 * (period - 1)
    return 10 * (period - 1);
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
